import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "main-container"
};
const _hoisted_2 = {
  class: "filter-container"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  key: 2
};
const _hoisted_8 = {
  class: "action-list"
};
import Pagination from '@/components/Pagination.vue';
import { useRouter } from 'vue-router';
import { useStore } from '@/store';
import SelectBrand from '@/components/SelectBrand.vue';
import { getCurrentInstance, reactive, onMounted, ref } from 'vue';
import Keys from '@/constant/key';
import { UserMutationTypes } from '@/store/modules/user/mutation-types';
import Lunar from 'lunar-javascript';
import { isWithinRange, isNationalDayRange } from '@/utils/index';
import { joinParams } from '@/utils/index';
export default /*@__PURE__*/_defineComponent({
  __name: 'SpringRuleList',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const uploadRef = ref();
    const userType = store.state.user.userInfo.user_type;
    const userGroups = store.state.user.userInfo.group_id.split(',');
    const filters = reactive({
      type: '',
      way_type: '',
      brand_id: '',
      mft_id: '',
      ship_type: '',
      status: '',
      title: '',
      start_date: '',
      end_date: '',
      page: 1,
      page_size: 10,
      source: route.meta.v
    });
    const state = reactive({
      product_ids: [],
      isTrue: 0,
      mft: 0,
      isSweet: 0,
      dialogVisibleNew: false,
      distribution_rule_id: '',
      allWhiteReasonFilled: 0,
      allReason: '',
      allNoReason: '',
      is_white_list: '',
      ship_type: ''
    });
    const tableData = ref([]);
    const total = ref(0);
    // 跳转至编辑页
    const toEdit = (row, t) => {
      router.push(`/merchant-admin/spring-rule-edit?id=${row.id}&t=${t}`);
      // if(userType==1){
      //     router.push(`/merchant-admin/spring-rule-edit?id=${row.distribution_rule_id}&t=${t}`)
      // }else{
      //     router.push(`/merchant-admin/spring-rule-edit?id=${row.id}&t=${t}`)
      // }
    };
    // 跳转至编辑页
    // const toAdd = () => {
    //     router.push(`/merchant-admin/spring-rule-edit`)
    // }
    const onUploadSuccess = async res => {
      const {
        code,
        data,
        msg
      } = res;
      if (code == 200) {
        proxy.$message({
          type: 'success',
          message: msg
        });
        dialogBeforeCloseNew();
        getList();
      } else {
        return proxy.$message({
          type: 'error',
          message: msg
        });
      }
    };
    //确定上传
    const dialogSubmit = () => {
      proxy.$refs.uploadRef.submit();
    };
    //打开上传更新弹窗
    // const openDialogNew = () => {
    //     state.dialogVisibleNew = true
    // }
    // 关闭上传更新弹框
    const dialogBeforeCloseNew = () => {
      //清除数据
      if (uploadRef.value) {
        uploadRef.value.clearFiles();
      }
      state.ship_type = '';
      state.dialogVisibleNew = false;
      getList();
    };
    //审核过的商品不可再进行审核
    const selectable = row => {
      if (row.status == 1 || row.status == 2) {
        return false;
      } else {
        return true;
      }
    };
    const isFestival = date => {
      // 获取当前年份
      var currentYear = new Date().getFullYear();
      // 获取当年春节
      var lunar = Lunar.Lunar.fromYmd(currentYear, 1, 1);
      // 获取下年春节
      var lunarNext = Lunar.Lunar.fromYmd(currentYear + 1, 1, 1);
      // 转阳历春节日期
      var solar = lunar.getSolar().toString();
      var solarNext = lunarNext.getSolar().toString();
      //判断是否为当前春节前30天和春节后8天
      const newYearStart = new Date(solar).getTime() - 1000 * 60 * 60 * 24 * 30;
      const newYearEnd = new Date(solar).getTime() + 1000 * 60 * 60 * 24 * 8;
      //判断是否为下年春节前30天和春节后8天
      const NextYearStart = new Date(solarNext).getTime() - 1000 * 60 * 60 * 24 * 30;
      const NextYearEnd = new Date(solarNext).getTime() + 1000 * 60 * 60 * 24 * 8;
      return isWithinRange(date, newYearStart, newYearEnd) || isWithinRange(date, NextYearStart, NextYearEnd);
    };
    const isSpecialDate = () => {
      const currentDate = new Date().getTime(); // 当前日期时间戳
      // 判断是否在国庆节或春节日期范围内
      if (isFestival(currentDate) || isNationalDayRange(currentDate)) {
        return true;
      }
      return false;
    };
    //通过
    const toStatus = (row, status) => {
      /*
      * 1. 审核通过时且在国庆期间及国庆前半个月、春节前30天和春节后8天，白名单弹窗是否显示
      * 2. 不在此期间商户有填写申请原因则也进行弹窗
      */
      //判断是否批量通过
      if (!state.distribution_rule_id) {
        state.distribution_rule_id = row.distribution_rule_id;
      }
      if (status == 1) {
        //白名单原因全是空返回false
        if (state.allWhiteReasonFilled && state.distribution_rule_id.length > 0) {
          return proxy.$message({
            type: 'error',
            message: '填写白名单原因和未填写白名单原因的不可同时通过'
          });
        }
        //审核时无需判断是否在白名单时间内 
        if (row.white_reson || state.allReason) {
          proxy.$confirm(`是否确认加入白名单`, '提示', {
            type: 'warning'
          }).then(() => {
            state.is_white_list = 1;
            proxy.$confirm(`是否确认${status == 1 ? '通过' : '驳回'}`, '提示', {
              type: 'warning'
            }).then(() => {
              proxy.$http.post('/admin/brands/oper_cj_status', {
                distribution_rule_id: state.distribution_rule_id,
                status,
                is_white_list: state.is_white_list
              }).then(res => {
                const {
                  code,
                  data,
                  msg
                } = res;
                if (code != 200) {
                  return proxy.$message({
                    type: 'error',
                    message: msg
                  });
                }
                proxy.$message({
                  type: 'success',
                  message: '成功'
                });
                state.distribution_rule_id = '';
                state.allReason = '';
                state.allNoReason = '';
                // 菜单提醒数字减一
                store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, 'cj_distribution_rule');
                getList();
                location.reload();
              });
            }).catch(() => {
              console.log('取消');
            });
          });
        } else {
          proxy.$confirm(`是否确认${status == 1 ? '通过' : '驳回'}`, '提示', {
            type: 'warning'
          }).then(() => {
            proxy.$http.post('/admin/brands/oper_cj_status', {
              distribution_rule_id: state.distribution_rule_id,
              status,
              is_white_list: state.is_white_list
            }).then(res => {
              const {
                code,
                data,
                msg
              } = res;
              if (code != 200) {
                return proxy.$message({
                  type: 'error',
                  message: msg
                });
              }
              proxy.$message({
                type: 'success',
                message: '成功'
              });
              state.distribution_rule_id = '';
              // 菜单提醒数字减一
              store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, 'cj_distribution_rule');
              getList();
              location.reload();
            });
          }).catch(() => {
            console.log('取消');
          });
        }
      } else {
        proxy.$confirm(`是否确认${status == 1 ? '通过' : '驳回'}`, '提示', {
          type: 'warning'
        }).then(() => {
          proxy.$http.post('/admin/brands/oper_cj_status', {
            distribution_rule_id: state.distribution_rule_id,
            status,
            is_white_list: state.is_white_list
          }).then(res => {
            const {
              code,
              data,
              msg
            } = res;
            if (code != 200) {
              return proxy.$message({
                type: 'error',
                message: msg
              });
            }
            proxy.$message({
              type: 'success',
              message: '成功'
            });
            state.distribution_rule_id = '';
            // 菜单提醒数字减一
            store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, 'cj_distribution_rule');
            getList();
            location.reload();
          });
        }).catch(() => {
          console.log('取消');
        });
      }
    };
    //单条通过
    const toOneStatus = (row, status) => {
      /*
      * 1. 审核通过时且在国庆期间及国庆前半个月、春节前30天和春节后8天，白名单弹窗是否显示
      * 2. 不在此期间商户有填写申请原因则也进行弹窗
      */
      //判断是否批量通过
      // if(!state.distribution_rule_id){
      //     state.distribution_rule_id = row.distribution_rule_id;
      // }
      if (status == 1) {
        //白名单原因全是空返回false
        if (state.allWhiteReasonFilled && state.distribution_rule_id.length > 0) {
          return proxy.$message({
            type: 'error',
            message: '填写白名单原因和未填写白名单原因的不可同时通过'
          });
        }
        //审核时无需判断是否在白名单时间内 
        if (row.white_reson || state.allReason) {
          proxy.$confirm(`是否确认加入白名单`, '提示', {
            type: 'warning'
          }).then(() => {
            state.is_white_list = 1;
            proxy.$confirm(`是否确认${status == 1 ? '通过' : '驳回'}`, '提示', {
              type: 'warning'
            }).then(() => {
              proxy.$http.post('/admin/brands/oper_cj_status', {
                distribution_rule_id: row.distribution_rule_id,
                status,
                is_white_list: state.is_white_list
              }).then(res => {
                const {
                  code,
                  data,
                  msg
                } = res;
                if (code != 200) {
                  return proxy.$message({
                    type: 'error',
                    message: msg
                  });
                }
                proxy.$message({
                  type: 'success',
                  message: '成功'
                });
                state.distribution_rule_id = '';
                state.allReason = '';
                state.allNoReason = '';
                // 菜单提醒数字减一
                store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, 'cj_distribution_rule');
                getList();
                // location.reload()
              });
            }).catch(() => {
              console.log('取消');
            });
          });
        } else {
          proxy.$confirm(`是否确认${status == 1 ? '通过' : '驳回'}`, '提示', {
            type: 'warning'
          }).then(() => {
            proxy.$http.post('/admin/brands/oper_cj_status', {
              distribution_rule_id: row.distribution_rule_id,
              status,
              is_white_list: state.is_white_list
            }).then(res => {
              const {
                code,
                data,
                msg
              } = res;
              if (code != 200) {
                return proxy.$message({
                  type: 'error',
                  message: msg
                });
              }
              proxy.$message({
                type: 'success',
                message: '成功'
              });
              state.distribution_rule_id = '';
              // 菜单提醒数字减一
              store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, 'cj_distribution_rule');
              getList();
              // location.reload()
            });
          }).catch(() => {
            console.log('取消');
          });
        }
      } else {
        proxy.$confirm(`是否确认${status == 1 ? '通过' : '驳回'}`, '提示', {
          type: 'warning'
        }).then(() => {
          proxy.$http.post('/admin/brands/oper_cj_status', {
            distribution_rule_id: row.distribution_rule_id,
            status,
            is_white_list: state.is_white_list
          }).then(res => {
            const {
              code,
              data,
              msg
            } = res;
            if (code != 200) {
              return proxy.$message({
                type: 'error',
                message: msg
              });
            }
            proxy.$message({
              type: 'success',
              message: '成功'
            });
            state.distribution_rule_id = '';
            // 菜单提醒数字减一
            store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, 'cj_distribution_rule');
            getList();
            // location.reload()
          });
        }).catch(() => {
          console.log('取消');
        });
      }
    };
    // 选中监听
    const onSelectionChange = val => {
      state.distribution_rule_id = val.filter(item => item.status == 0).map(item => item.distribution_rule_id).join(',');
      state.allReason = val.every(item => item.white_reson !== null && item.white_reson !== '');
      state.allNoReason = val.every(item => item.white_reson == null || item.white_reson == '');
      //全都填写原因==false 且 全没填写原因 == false 则代表即没全填写原因，也没全不填写原因
      if (state.allReason === false && state.allNoReason === false) {
        //即代表没有混合的
        state.allWhiteReasonFilled = 1;
      } else {
        //则代表有混合的
        state.allWhiteReasonFilled = 0;
      }
    };
    // 获取列表数据
    const getList = () => {
      if (userType == 1) {
        proxy.$http.get('/admin/brands/get_cj_examinelist', filters).then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code != 200) {
            return proxy.$message({
              type: 'error',
              message: msg
            });
          }
          tableData.value = data.data;
          total.value = data.total;
        });
      } else {
        proxy.$http.get('/admin/brands/get_cj_distribution_rule_list', filters).then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code != 200) {
            return proxy.$message({
              type: 'error',
              message: msg
            });
          }
          tableData.value = data.data;
          total.value = data.total;
        });
      }
    };
    const toExport = type => {
      if (!filters.ship_type) {
        return proxy.$message({
          type: 'error',
          message: '请选择配送类型再进行导出'
        });
      }
      window.open(`${Keys.baseUrl}/admin/brands/get_cj_examinelist?${joinParams({
        ...filters,
        user_id: store.state.user.userInfo.id
      })}&is_export=${type}`);
    };
    const onBrandChange = val => {
      filters.brand_id = val;
    };
    const search = () => {
      filters.page = 1;
      getList();
    };
    const onPageChange = val => {
      filters.page = val;
      getList();
    };
    const onSizeChange = val => {
      filters.page_size = val;
      getList();
    };
    onMounted(() => {
      getList();
      isSpecialDate();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.ship_type,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filters.ship_type = $event),
        clearable: "",
        placeholder: "请选择配送类型"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "快递",
          value: 1
        }), _createVNode(_component_el_option, {
          label: "上门/自提",
          value: 2
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_select, {
        class: "filter-item",
        filterable: "",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filters.status = $event),
        placeholder: "审核状态",
        clearable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "待审核",
          value: 0
        }), _createVNode(_component_el_option, {
          label: "通过",
          value: 1
        }), _createVNode(_component_el_option, {
          label: "驳回",
          value: 2
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.product_name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filters.product_name = $event),
        modelModifiers: {
          trim: true
        },
        placeholder: "商品名称",
        style: {
          "width": "170px"
        },
        clearable: ""
      }, null, 8, ["modelValue"]), _createVNode(SelectBrand, {
        onBrandChange: onBrandChange
      }), _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_date,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filters.start_date = $event),
        "value-format": "YYYY-MM-DD",
        placeholder: "提交开始时间",
        style: {
          "width": "150px"
        }
      }, null, 8, ["modelValue"]), _cache[13] || (_cache[13] = _createElementVNode("span", {
        class: "filter-divider"
      }, "-", -1)), _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_date,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => filters.end_date = $event),
        "value-format": "YYYY-MM-DD",
        placeholder: "提交结束时间",
        style: {
          "width": "150px"
        }
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[5] || (_cache[5] = $event => search())
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("搜索")])),
        _: 1
      }), _unref(userType) == 1 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "filter-btn",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = $event => toExport(1))
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode(" 导出 ")])),
        _: 1
      })) : _createCommentVNode("", true)]), _createVNode(_component_el_table, {
        ref: "multipleTableRef",
        data: tableData.value,
        stripe: "",
        border: "",
        onSelectionChange: onSelectionChange,
        "row-key": "id"
      }, {
        default: _withCtx(() => [filters.source == 2 ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 0,
          type: "selection",
          selectable: selectable,
          "reserve-selection": true,
          width: "55"
        })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
          prop: "id",
          label: "ID"
        }), _unref(userType) == 1 ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 1,
          prop: "user_name",
          label: "配规上传角色"
        })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
          prop: "ship_type",
          label: "配送类型"
        }, {
          default: _withCtx(scope => [scope.row.ship_type == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_3, "快递")) : _createCommentVNode("", true), scope.row.ship_type == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_4, "上门/自提")) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "status",
          width: "100",
          label: "审核状态"
        }, {
          default: _withCtx(scope => [scope.row.status == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_5, "待审核")) : _createCommentVNode("", true), scope.row.status == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_6, "审核通过")) : _createCommentVNode("", true), scope.row.status == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_7, "驳回")) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "rule_start_date",
          label: "配规开始时间"
        }), _createVNode(_component_el_table_column, {
          prop: "rule_end_date",
          label: "配规结束时间"
        }), _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌"
        }), _createVNode(_component_el_table_column, {
          prop: "city_name",
          label: "城市"
        }), _createVNode(_component_el_table_column, {
          prop: "product_id",
          width: "100",
          label: "商品id"
        }), _createVNode(_component_el_table_column, {
          prop: "product_name",
          width: "100",
          label: "商品"
        }), _createVNode(_component_el_table_column, {
          prop: "distribution_range",
          width: "100",
          label: "配送范围描述"
        }), _createVNode(_component_el_table_column, {
          prop: "ship_times",
          label: "配送时间段"
        }), _createVNode(_component_el_table_column, {
          prop: "take_times",
          label: "自提时间段"
        }), _createVNode(_component_el_table_column, {
          prop: "ship_amount",
          label: "配送费"
        }), _createVNode(_component_el_table_column, {
          prop: "white_reson",
          label: "申请白名单原因"
        }), _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "提交时间"
        }), _createVNode(_component_el_table_column, {
          prop: "examine_time",
          label: "审核时间"
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          width: "110",
          fixed: "right"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_8, [_unref(userType) == 2 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            disabled: scope.row.status !== 2,
            type: "primary",
            size: "small",
            onClick: $event => toEdit(scope.row, 1)
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode(" 编辑 ")])),
            _: 2
          }, 1032, ["disabled", "onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: $event => toEdit(scope.row, 2)
          }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode(" 查看 ")])),
            _: 2
          }, 1032, ["onClick"]), filters.source == 2 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            disabled: scope.row.status !== 0,
            type: "primary",
            size: "small",
            onClick: $event => toOneStatus(scope.row, 1)
          }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode(" 通过 ")])),
            _: 2
          }, 1032, ["disabled", "onClick"])) : _createCommentVNode("", true), filters.source == 2 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            disabled: scope.row.status !== 0,
            type: "primary",
            size: "small",
            onClick: $event => toOneStatus(scope.row, 2)
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode(" 驳回 ")])),
            _: 2
          }, 1032, ["disabled", "onClick"])) : _createCommentVNode("", true)])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createVNode(Pagination, {
        currentPage: filters.page,
        total: total.value,
        onPageChange: onPageChange,
        onSizeChange: onSizeChange
      }, null, 8, ["currentPage", "total"]), filters.source == 2 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "primary",
        size: "small",
        onClick: _cache[7] || (_cache[7] = $event => toStatus(state.distribution_rule_id, 1))
      }, {
        default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode(" 批量通过 ")])),
        _: 1
      })) : _createCommentVNode("", true), filters.source == 2 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        type: "primary",
        size: "small",
        onClick: _cache[8] || (_cache[8] = $event => toStatus(state.distribution_rule_id, 2))
      }, {
        default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode(" 批量驳回 ")])),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        title: "批量上传特殊配规",
        modelValue: state.dialogVisibleNew,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => state.dialogVisibleNew = $event),
        "before-close": dialogBeforeCloseNew
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: dialogBeforeCloseNew
        }, {
          default: _withCtx(() => _cache[26] || (_cache[26] = [_createTextVNode("取 消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: dialogSubmit
        }, {
          default: _withCtx(() => _cache[27] || (_cache[27] = [_createTextVNode("确 定")])),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "inForm",
          model: state.currRow,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "配送类型：",
            style: {
              "width": "400px"
            },
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: state.ship_type,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => state.ship_type = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode("快递")])),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 2
              }, {
                default: _withCtx(() => _cache[21] || (_cache[21] = [_createTextVNode("上门/自提")])),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [state.ship_type == 1 ? (_openBlock(), _createBlock(_component_el_upload, {
              key: 0,
              class: "upload-demo",
              ref_key: "uploadRef",
              ref: uploadRef,
              action: `/api/admin/brands/do_cj_same_rule?user_id=${_unref(store).state.user.userInfo.id}&user_name=${_unref(store).state.user.userInfo.username}&ship_type=1`,
              "on-success": onUploadSuccess,
              accept: ".xls,.xlsx",
              "auto-upload": false
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                size: "small"
              }, {
                default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("点击上传")])),
                _: 1
              })]),
              _: 1
            }, 8, ["action"])) : _createCommentVNode("", true), state.ship_type == 2 ? (_openBlock(), _createBlock(_component_el_upload, {
              key: 1,
              class: "upload-demo",
              ref_key: "uploadRef",
              ref: uploadRef,
              action: `/api//admin/brands/do_cj_ship_rule?user_id=${_unref(store).state.user.userInfo.id}&user_name=${_unref(store).state.user.userInfo.username}&ship_type=2`,
              "on-success": onUploadSuccess,
              accept: ".xls,.xlsx",
              "auto-upload": false
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                size: "small"
              }, {
                default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("点击上传")])),
                _: 1
              })]),
              _: 1
            }, 8, ["action"])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [state.ship_type == 1 ? (_openBlock(), _createBlock(_component_el_link, {
              key: 0,
              href: `${_unref(Keys).baseUrl}/admin/brands/downLoad_same_excel`
            }, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [_createTextVNode("下载快递类模版")])),
              _: 1
            }, 8, ["href"])) : _createCommentVNode("", true), state.ship_type == 2 ? (_openBlock(), _createBlock(_component_el_link, {
              key: 1,
              href: `${_unref(Keys).baseUrl}/admin/brands/downLoad_delivery_excel`
            }, {
              default: _withCtx(() => _cache[25] || (_cache[25] = [_createTextVNode("下载上门/自提类模版")])),
              _: 1
            }, 8, ["href"])) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});